import script from "./ModalCambiarPass.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCambiarPass.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCambiarPass.vue?vue&type=style&index=0&id=5c850312&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c850312"]])

export default __exports__